module.exports = __webpack_public_path__ + "static/media/TonoDaruma_07A.96b1de6b.gif";